import React from 'react';
import { TextField, Button } from '@material-ui/core';
import axiosI from '../../../../Service/service';
import * as constants from '../../../../Constants';

class ChangePassword extends React.Component{

    constructor() {
        super();
        this.state={
            formData: {
                password: "",
                newPassword: "",
            },
            passwordError: false,
            passwordError2:false,
            disabled: true,
        };
    }

    textChange = (e) => {
        let {formData} = this.state;
        formData[e.target.id] = e.target.value;
        this.setState({formData});
    };

    validate = () => {
        let {formData, disabled, passwordError} = this.state;
        let data = {
            OldPassword: formData['password'],
            UserId: this.props.user.AppUser.UserId
        };
        axiosI.post(constants.API.checkOldPasswordApi, data).then((response) => {
            disabled = !response.data.results.ResponseCode;
            passwordError = !response.data.results.ResponseCode;
            this.setState({disabled, passwordError});
        }).catch((err) => {
            console.log(err);
        });
        this.setState({formData, disabled, passwordError});
    };

    updatePassword = () => {
        let {formData, passwordError2} = this.state;
        let reg = /^\S{6,16}$/;
        let result = reg.test(this.state.formData['newPassword']);
        if (result) {
            let oldData = {
                OldPassword: formData['password'],
                UserId: this.props.user.AppUser.UserId
            };
            let data = {
                FieldName: 'Password',
                FieldValue: this.state.formData['newPassword'],
                UserId: this.props.user.AppUser.UserId
            };
            axiosI.post(constants.API.checkOldPasswordApi, oldData).then((response) => {
                if(response.data.results.ResponseCode) {
                    axiosI.post(constants.API.updateUserInfoApi, data).then((response) => {
                        if (response.data.results.ResponseCode) {
                            this.props.showAlert(true,'Password changed successfully.');
                            this.props.handleOpen();
                            passwordError2 = false;
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            }).catch((err) => {
                console.log(err);
            });
        }
        else {
            passwordError2 = true;
        }
        this.setState({ passwordError2 });
    };

    render() {
        const {classes} = this.props;
        const { password, passwordError, newPassword, disabled, passwordError2 } = this.state;
        return (
            <React.Fragment>
                <div className="control-wrapper">
                    <TextField
                        id="password"
                        type="password"
                        margin="normal"
                        placeholder="Enter Old Password"
                        fullWidth
                        inputProps={{className: classes.inputText}}
                        value={password}
                        onChange={this.textChange}
                        onBlur={this.validate}
                        required
                    />
                    {passwordError &&
                    <span style={{color: 'red'}}>Password is incorrect.Please Enter correct Password</span>}
                    <TextField
                        id="newPassword"
                        type="password"
                        margin="normal"
                        placeholder="Enter New Password"
                        fullWidth
                        inputProps={{className: classes.inputText}}
                        value={newPassword}
                        onChange={this.textChange}
                        required
                        disabled={disabled}
                    />
                    {passwordError2 &&
                    <span style={{color: 'red'}}>Password must be 8-16 characters long and cannot contain space.</span>}
                    <div className="update-password-btn">
                        <Button className="update-password-button" onClick={this.updatePassword}>Update Profile</Button>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default ChangePassword;
